import {SxProps} from '@mui/material';

import {greenColors, orangeColors} from '../../../../../../layouts/theme/designSystem';

export const paperStyle: SxProps = {
  backgroundImage: 'none',
  backgroundColor: orangeColors[4],
  borderRadius: '16px',
  minHeight: {xs: 'fit-content', sm: '437px', md: '447px'},
  margin: '0 0 30px 0',
  width: '100%',
};

export const boardViewStyles: SxProps = {
  borderTop: `4px solid ${greenColors[100]}`,
  padding: '16px ',
  backgroundImage: 'none',
  borderRadius: '0px 0px 16px 16px',
  height: 'fit-content',
  marginBottom: '16px',
  '&:hover': {
    backggroundImage: 'none',
    backgroundColor: greenColors[40],
    cursor: 'pointer',
  },
};

export const typographyColors: SxProps = {
  color: greenColors[100],
};

export const buttonsStyle: SxProps = {
  color: 'black',
  backgroundColor: orangeColors[3],
  '&:hover': {
    backgroundColor: greenColors[40],
  },
  boxShadow: 'none',
  width: {xs: '100%', sm: '100%', md: '168px'},
};
